var ct_admin = 'CT Admin';
var coo_admin = 'COO Admin';
var tc = 'TC';
var gp = 'GP';
var doctor = 'Doctor';
var front_office = 'Front Office';
var location_manager = 'Location Manager';
var super_admin = 'Super Admin';
var lite = 'LITE';
var pro = 'PRO';
var enterprise = 'ENTERPRISE';

if (process.env.ENV === 'production') {
    var baseUrl = 'https://ortho.practicecatapult.com/backend/';
    var StripeKey = 'pk_live_054mDdGEPN4T55i22kQZjf0a';
    var stripe_client_id = 'ca_BjsbgLD3DdvOEnzpXKcSgjuRlxKSzCDB';
    var socket_url = "wss://ortho.practicecatapult.com/ws/?token=";
}else if (process.env.ENV === 'uat'){
    var baseUrl = 'https://uat.practicecatapult.com/backend/';
    var StripeKey = 'pk_test_xv7cmsol9WxtyW24qiOuA65A';
    var stripe_client_id = 'ca_BHWi0KNtn0HB5NJiU7LeJV37dvsgpQpW';
    var socket_url = "wss://uat.practicecatapult.com/ws/?token=";
}else if (process.env.ENV === 'qa'){
    var baseUrl = 'https://qa.practicecatapult.com/backend/';
    var StripeKey = 'pk_test_xv7cmsol9WxtyW24qiOuA65A';
    var stripe_client_id = 'ca_BHWi0KNtn0HB5NJiU7LeJV37dvsgpQpW';
    var socket_url = "wss://qa.practicecatapult.com/ws/?token=";
}else {
    var baseUrl = 'https://qa.practicecatapult.com/backend/';
    var StripeKey = 'pk_test_xv7cmsol9WxtyW24qiOuA65A';
    var stripe_client_id = 'ca_BHWi0KNtn0HB5NJiU7LeJV37dvsgpQpW';
    var socket_url = "wss://qa.practicecatapult.com/ws/?token=";
}

export const config: any = {
    // configuration for testing server
     baseUrl: baseUrl,
     photoUrl: '',
     socket_url: socket_url,

    // configuration for UAT server
    //baseUrl: 'http://34.199.160.147/backend/',
    //photoUrl: 'http://34.199.160.147/',
    package: 'package',
    storage_key: 'ct_access',
    role: 'ct_role',
    roleSwitched: 'role_switched',
    stripe_client_id : stripe_client_id,
    menu_list: 'menu_list',
    dentist: 'Dentist',
    patient: 'Patient',
    coo_admin: 'COO Admin',
    super_admin: 'Super Admin',
    StripeKey: StripeKey,
    gp: 'GP',
    tc: 'TC',
    doctor: 'Doctor',
    location_manager: 'Location Manager',
    ct_admin: 'CT Admin',
    front_office: 'Front Office',
    language: 'language',
    country: 'country',
    subscription_status: 'subscription_status',
    languages: [{ id: 'en', title: 'English' }],
    va_enabled: '',
    // publicPath: '/design-revamp',
    publicPath: '',
    followUpSideBarOpen: true,
    page_auth: {
        'vc-settings': { roles: [coo_admin] },
        'subscription': { roles: [coo_admin] },
        'case-study-list': { roles: [coo_admin, ct_admin, location_manager] },
        'doctor-referral-list': { roles: [coo_admin, tc, location_manager] },
        'patient-referral-list': { roles: [coo_admin, location_manager, tc], subscription: [pro, enterprise] },
        'reports': { roles: [coo_admin, location_manager, tc, ct_admin, doctor, super_admin] },
        'change-password': { roles: [coo_admin, location_manager, tc, ct_admin, doctor, front_office, super_admin] },
        'pricing': { roles: [coo_admin, location_manager] },
        'set-goals': { roles: [coo_admin, location_manager] },
        'geography-settings': { roles: [coo_admin] },
        'demographic-settings': { roles: [coo_admin, location_manager] },
        'practice-profile': { roles: [coo_admin] },
        'patient-gallery': { roles: [coo_admin] },
        'insurance-plan': { roles: [coo_admin, location_manager] },
        'referral-source': { roles: [coo_admin, location_manager] },
        'follow-up-communication': { roles: [coo_admin, tc, location_manager] },
        'virtual-consultation-communications': { roles: [coo_admin, tc, location_manager] },
        'parent-ortho-follow-up-communication': { roles: [coo_admin, location_manager, tc] },
        'patient-ortho-follow-up-communication': { roles: [coo_admin, location_manager, tc] },
        'profile': { roles: [coo_admin, tc, doctor, location_manager, ct_admin, front_office, super_admin] },
        'patient-file-list': { roles: [tc, doctor, location_manager, coo_admin, front_office] },
        'ct-category': { roles: [ct_admin] },
        'ct-promocode': { roles: [ct_admin] },
        'insurance-plan-management': { roles: [ct_admin] },
        'referral-source-management': { roles: [ct_admin] },
        'additional-appliance-options': { roles: [ct_admin] },
        'subscription-pricing': { roles: [ct_admin] },
        'add-case-study': { roles: [ct_admin, coo_admin, location_manager], subscription: [pro, enterprise] },
        'view-case-study': { roles: [ct_admin, coo_admin, location_manager] },
        'allocate-case-study': { roles: [ct_admin] },
        'language-settings': { roles: [coo_admin, location_manager] },
        'additional-options': { roles: [coo_admin, location_manager] },
        'ortho-calculator': { roles: [tc] },
        'patient-presenter': { roles: [tc] },
        'gp-gallery': { roles: [gp] },
        'patient-file-add': { roles: [tc, front_office] },
        'patient-file-view': { roles: [tc, doctor, front_office, coo_admin, location_manager] },
        'responsible-party-view': { roles: [tc, doctor, front_office, coo_admin, location_manager] },
        'responsible-party-list': { roles: [tc, doctor, front_office, coo_admin, location_manager] },
        'practice-list': { roles: [ct_admin] },
        'practice-add': { roles: [ct_admin] },
        'practice-view': { roles: [ct_admin] },
        'practice-delete': { roles: [ct_admin] },
        'enterprise-list': { roles: [ct_admin] },
        'enterprise-add': { roles: [ct_admin] },
        'enterprise-delete': { roles: [ct_admin] },
        'non-start-follow-up-touchpoints': { roles: [ct_admin] },
        'create-referral': { roles: [coo_admin, tc, location_manager] },
        'treatment-plan': { roles: [tc, doctor, coo_admin, location_manager, front_office] },
        'existing-treatment-plan': { roles: [tc, doctor, coo_admin, location_manager, front_office] },
        'user-list': { roles: [coo_admin, location_manager, ct_admin] },
        'user-add': { roles: [coo_admin, location_manager] },
        'user-view': { roles: [coo_admin, location_manager, ct_admin] },
        'email-template' : { roles: [coo_admin, tc, location_manager]},
        'super-admin-listing': { roles: [ct_admin] },
        'cart': { roles: [coo_admin] },
        'cart-success': { roles: [coo_admin] },
        'patient-payment-details': { roles: [coo_admin] },
        'online-payments': { roles: [coo_admin] },
        'recent-expired-quotes': { roles: [coo_admin, location_manager, tc] },
        'non-start-follow-up': { roles: [coo_admin, location_manager, tc] },
        'treatment-approval': { roles: [coo_admin, location_manager] },
        'contracts': { roles: [coo_admin, location_manager] },
        'dashboard-display-report': { roles: [coo_admin, location_manager] },
        'quote-touchpoints-settings': { roles: [coo_admin, location_manager] },
        'treatment-option-settings': { roles: [coo_admin, location_manager] },
        'activity-reports': { roles: [tc, doctor, coo_admin, location_manager, front_office, ct_admin, super_admin] },
        'payment-options': { roles: [coo_admin] },
        'pdf-password': { roles: [coo_admin] },
        'practice_contract_call_back': { roles: [coo_admin] },
        'retainer-program-management': { roles: [ct_admin] }
    },
    currency: {
        'USD' : '$',
        'EUR' : '€',
        'INR' : '₹',
        'CAD' : '$',
        'AUD' : '$',
    },
    dateFormat: {
        'US' : 'MM/DD',
        'IE' : 'DD/MM',
        'EN' : 'DD/MM',
        'AU' : 'MM/DD'
    },
    currencyNames: ['USD', 'EUR', 'INR', 'CAD', 'AUD'],
    emailRegex: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])+\.[a-zA-Z0-9-]{2,}?(?:\.[a-zA-Z](?:[a-zA-Z]{0,61}[a-zA-Z])?)*$/,
    emailRegexPattern: "^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])+\.[a-zA-Z0-9-]{2,}?(?:\.[a-zA-Z](?:[a-zA-Z]{0,61}[a-zA-Z])?)*$",
};